import React, { useState } from 'react'
import styles from './FAQAccordion.module.css'

const faqs = [
  {
    question: 'What makes Recooty’s AI job description generator unique?',
    answer:
      "We fuse deep recruitment intelligence, performance-based copywriting, and advanced SEO logic with our specialized AI writing models. This ensures the descriptions don't just fill a page - they perform, attracting and converting top candidates.",
  },
  {
    question: 'How is this better than just using ChatGPT or another LLM?',
    answer:
      "While ChatGPT is a powerful general-purpose tool, our AI job description generator is a specialist. It has been exclusively trained on tens of thousands of high-performing job descriptions, industry-specific data, and proven hiring language. It understands the nuances of recruitment in a way a general model can't.",
  },
  {
    question: 'Can I use this tool for any role, industry, or seniority level?',
    answer:
      'Yes. Our AI is highly adaptable. From entry-level and part-time roles to senior executive positions across tech, healthcare, finance, marketing, and more - our job description builder is designed to meet your specific needs.',
  },
  {
    question: 'Is this AI tool truly free?',
    answer:
      'Yes, our free AI job description generator is completely free to use for creating job descriptions. We also offer a comprehensive paid AI recruiting software for teams looking to fully automate their hiring pipeline.',
  },
  {
    question:
      'How does an AI-generated job description improve applicant quality?',
    answer:
      'By using precise, skill-focused, and industry-specific language, the AI D helps to pre-qualify candidates. It clearly communicates expectations and responsibilities, which deters unqualified applicants and strongly attracts those who are a perfect fit, saving you time and resources.',
  },
]

const FAQAccordion = () => {
  const [openIndex, setOpenIndex] = useState(0)

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className={styles.container}>
      {/* Left Column */}
      <div className={styles.leftColumn}>
        <h2 className={styles.heading}>
          Got Questions? Have a <br /> Look Here!
        </h2>
        <p className={styles.subtext}>
          Couldn’t find what you were looking for?
        </p>
        <p className={styles.subtext}>Write to us at.</p>
        <a href="mailto:support@recooty.com" className={styles.emailLink}>
          support@recooty.com
        </a>
      </div>

      {/* Right Column - FAQ Accordion */}
      <div className={styles.rightColumn}>
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`${styles.faqCard} ${
              openIndex === index ? styles.activeCard : ''
            }`}
          >
            <button onClick={() => toggle(index)} className={styles.faqButton}>
              <h3 className={styles.faqQuestion}>{faq.question}</h3>
              <span
                className={styles.icon}
                style={{
                  transition: 'transform 0.2s',
                  transform:
                    openIndex === index ? 'rotate(45deg)' : 'rotate(0deg)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {/* Plus Icon SVG (rotated to X when open) */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className={styles.iconSvg}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 4v16m8-8H4"
                  />
                </svg>
              </span>
            </button>

            <div
              className={`${styles.faqAnswer} ${
                openIndex === index ? styles.answerOpen : ''
              }`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FAQAccordion
